// src/pages/Cart.js
import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import CartItem from '../components/cart/CartItem';
import CartSummary from '../components/cart/CartSummary';
import { fadeIn } from '../utils/gsapAnimations';

function Cart() {
  const pageRef = useRef(null);
  const { cart } = useCart();

  useEffect(() => {
    fadeIn(pageRef.current, 0.3);
  }, []);

  return (
    <div ref={pageRef} className="bg-cream py-12 lg:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-playfair-display font-semibold text-primary mb-10 lg:mb-12 text-center tracking-tight">
          Your Cart
        </h1>

        {cart.length > 0 ? (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
            {/* Cart Items */}
            <div className="lg:col-span-2 space-y-6 lg:space-y-8">
              {cart.map((item) => (
                <div
                  key={item.variantKey}
                  className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100/70"
                >
                  <CartItem item={item} />
                </div>
              ))}
            </div>

            {/* Summary Sidebar */}
            <div className="lg:col-span-1">
              <div className="bg-white rounded-2xl shadow-lg p-6 lg:p-8 sticky top-8 border border-gray-100">
                <CartSummary />
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center py-16 lg:py-24">
            <div className="max-w-md mx-auto">
              <p className="text-xl sm:text-2xl font-montserrat text-primary mb-6 leading-relaxed">
                Your cart is empty.
              </p>
              <p className="text-lg font-montserrat text-secondary mb-10">
                Looks like you haven’t added anything yet. Start shopping now!
              </p>
              <Link
                to="/shop"
                className="inline-block bg-primary text-cream font-montserrat py-4 px-10 rounded-full text-lg hover:bg-primary/90 transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5 duration-300"
                aria-label="Shop now"
              >
                Shop Now
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Cart;